import React from 'react';

import image from 'src/assets/img/channel_revcontent.png';
import ImageIcon from 'src/components/ImageIcon';
import PropTypes from 'prop-types';

const ChannelRevcontent = ({ monochrome, ...props }) => (
  <ImageIcon image={image} {...props} />
);

ChannelRevcontent.propTypes = {
  monochrome: PropTypes.bool,
};
ChannelRevcontent.defaultProps = {
  monochrome: false,
};

export default ChannelRevcontent;
